export const VIEW_TEACHER_CONTENT_BUTTON_HEIGHT = 56;
